import Rule from "./rule";

class CartIncludesRule extends Rule {
  type = "cart.includes";

  constructor(config = {}) {
    super(config);

    try {
      this.hydrateMeta();
    } catch (e) {
      console.error(this.logPrefix, 'Failed to hydrate meta', e);
    }
  }

  evaluate(data) {
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Config', this.config);
    let pass = true;
    let variants = this.config.variants ? Array.isArray(this.config.variants) ? this.config.variants : [this.config.variants] : [];
    let products = this.config.products ? Array.isArray(this.config.products) ? this.config.products : [this.config.products] : [];
    pass = data.cart.some(item => {
      return variants.includes(item.id) || products.includes(item.product_id);
    });

    // TODO need to check NUMBER of passes here, so limit works on actions
    // that is, is 'addV2' limit is 3, then we need to check if there are 3 rule passes

    this.addLog(pass, "In cart", pass ? "In cart" : "Not in cart");
    
    console.log('Pass?', pass);
    console.groupEnd();
    return pass;
  }

  explain() {
    let message = "Cart includes";
    let submessages = [
      ...(this.config.variants || []).map(id => `${MP.Logger.variant({ title: this.meta[id]?.title, id })} from ${MP.Logger.product({ title: this.meta[id]?.product.title, id: this.meta[id]?.product.id.split("/").pop() })}`),
      ...(this.config.products || []).map(id => `TODO`)
    ];
    
    return `${message} ${submessages.join(" or ")}`;
  }

  async hydrateMeta() {
    const graphQlIds = [
      ...(this.config.variants || []).map(id => MP.Helpers.idToGraphQlId(id, "variant")),
      ...(this.config.products || []).map(id => MP.Helpers.idToGraphQlId(id, "product"))
    ];
    
    const result = await MP.Helpers.executeGQL(`{
      nodes(ids: ${JSON.stringify(graphQlIds)}) {
        ... on ProductVariant {
          id
          title
          product {
            id
            title
          }
        }
        ... on Product {
          id
          title
        }
      }
    }`, {});
    
    result.data.nodes.forEach(node => {
      this.meta[node.id.split("/").pop()] = node;
    });
  }
}

export default CartIncludesRule;